export default {
    namespaced: true,
    state: {
       snackBars: []
    },
    mutations: {
        setSnackBar(state,payload) {
            // state.snackBars = [payload];
            state.snackBars = state.snackBars.concat(payload);
        }
    }, 
    actions: {
        setSnackBars({ commit }, payload) {
            payload.showing = true;
            // payload.timeout = 10000000;
            payload.color = payload.color || 'success';
            commit('setSnackBar', payload);
        }
      },
}